import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@isophi/core-legacy';
import { ChildGroupSuggestion } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { map, Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { toCamelcaseFun } from '../../core/utils/object.utils';

@Injectable({
  providedIn: 'root',
})
export class WorkplaceApiService {
  constructor(private httpClient: HttpClient, private authService: AuthService, private translocoService: TranslocoService) {}

  getClassesSuggestions(workplaceUuid: string): Observable<ChildGroupSuggestion[]> {
    const headers = this.buildHeaders(workplaceUuid);
    const url = `${environment.api}/classes/suggestions/`;

    return this.httpClient.get<ChildGroupSuggestion[]>(url, { headers }).pipe(map((response) => toCamelcaseFun(response)));
  }

  private buildHeaders(workplaceUuid: string): HttpHeaders {
    let headers = new HttpHeaders();

    if (this.authService.accessToken) {
      headers = headers.set('Authorization', 'Bearer ' + this.authService.accessToken);
    }

    headers = headers.set('Accept-Language', this.translocoService.getActiveLang());
    headers = headers.set('X-Current-Kindergarten-UUID', workplaceUuid);

    return headers;
  }
}
